import BaseStyle from '@primevue/core/base/style';

var DynamicDialogStyle = BaseStyle.extend({
  name: 'dynamicdialog'
});

export { DynamicDialogStyle as default };
//# sourceMappingURL=index.mjs.map
